export default __webpack_public_path__ + "static/media/he.e20bfdc4.svg";